import React, { useEffect, useMemo, useRef, useState } from 'react';
import './WizardSpeechPlayback.scss';

const FIRST_SEGMENT_DELAY_MS = 120;
const STEP_MS = 36;

const splitSpeechTokens = (text) => {
    if (!text) {
        return [];
    }
    return text.split(/(\s+)/).filter((part) => part.length > 0);
};

const WizardSpeechPlayback = ({ text = '', animationKey = '', className = '' }) => {
    const tokens = useMemo(() => splitSpeechTokens(text), [text]);
    const [visibleCount, setVisibleCount] = useState(0);
    const timersRef = useRef([]);

    useEffect(() => {
        timersRef.current.forEach(clearTimeout);
        timersRef.current = [];
        setVisibleCount(0);

        if (!tokens.length) {
            return () => {
                timersRef.current.forEach(clearTimeout);
                timersRef.current = [];
            };
        }

        tokens.forEach((_, index) => {
            const at = FIRST_SEGMENT_DELAY_MS + index * STEP_MS;
            const timerId = setTimeout(() => {
                setVisibleCount(index + 1);
            }, at);
            timersRef.current.push(timerId);
        });

        return () => {
            timersRef.current.forEach(clearTimeout);
            timersRef.current = [];
        };
    }, [animationKey, text, tokens]);

    if (!text) {
        return null;
    }

    return (
        <p className={`wizard-speech-narrative font-italic text-muted mb-4 ${className}`.trim()}>
            {tokens.map((token, index) => (
                <span
                    key={`${animationKey}-${index}-${token}`}
                    className={`wizard-speech-segment${index < visibleCount ? ' wizard-speech-segment--visible' : ''}`}
                >
                    {token}
                </span>
            ))}
        </p>
    );
};

export default WizardSpeechPlayback;
export { FIRST_SEGMENT_DELAY_MS, STEP_MS };
